module.exports = new __parcel__URL__("add-on-2.f05f4ef7.svg").toString();